import {DataGranularity} from '../../../api/types';
import * as Units from '../../Units';
import {DateTimeConfig} from '../../Dates';
import {
  createXAxisConfig,
  createYAxisConfig,
  createTooltipConfig,
  createGridConfig,
  createLegendConfig,
} from '../builders';
import {ChartTheme, getMetricColor} from '../theme';
import {ChartConfig, ChartDataPoint, SeriesConfig} from '../types';

export interface SolarChartOptions {
  data: ChartDataPoint[];
  theme: ChartTheme;
  timezone: string;
  units: Units.Units;
  granularity: DataGranularity;
  height?: number;
  comparisonData?: ChartDataPoint[];
  comparisonLabel?: string;
  dateTimeConfig?: DateTimeConfig;
}

export const solarChart = (options: SolarChartOptions): ChartConfig => {
  const {
    data,
    theme,
    timezone,
    units,
    granularity,
    height = 250,
    comparisonData,
    comparisonLabel,
    dateTimeConfig,
  } = options;

  const series: SeriesConfig[] = [
    {
      id: 'solar-radiation',
      type: comparisonData ? 'line' : 'area',
      dataKey: 'SOLAR_RADIATION',
      name: 'Solar Radiation',
      color: getMetricColor('solar', theme.isDark),
      yAxisIndex: 0,
      interpolation: 'monotone',
      fillOpacity: 0.3,
      lineWidth: 2,
      showMarkers: false,
      zIndex: 1,
    },
  ];

  if (comparisonData) {
    series.push({
      id: 'solar-comparison',
      type: 'line',
      dataKey: 'SOLAR_RADIATION_COMP',
      name: comparisonLabel ?? 'Comparison',
      color: theme.colors.textSecondary,
      yAxisIndex: 0,
      interpolation: 'monotone',
      lineWidth: 2,
      dashArray: '5 3',
      showMarkers: false,
      zIndex: 0,
    });
  }

  return {
    height,
    data,
    series,
    xAxis: createXAxisConfig({type: 'datetime', timezone, granularity, theme}),
    yAxes: [
      createYAxisConfig({
        id: 'solar',
        metric: 'SOLAR_RADIATION',
        units,
        theme,
        domain: [0, 'auto'],
        unitLabel: 'W/m²',
      }),
    ],
    tooltip: createTooltipConfig({
      timezone,
      granularity,
      metric: 'SOLAR_RADIATION',
      units,
      theme,
      dateTimeConfig,
    }),
    legend: createLegendConfig(series.length > 1, theme),
    grid: createGridConfig(theme),
    animate: true,
  };
};
